import {Routes} from '@angular/router';
import { Authority } from '../constants/authority.constants';

export const CommonLayout_ROUTES: Routes = [

  // Dashboard
  {
    path: 'dashboard',
    data: { title: 'Dashboard', authorities: [Authority.ADMIN]},
    loadChildren: () => import('../../modules/dashboard/dashboard.module').then(m => m.DashboardModule),
  },
  {
    path: 'documents',
    data: { title: 'Documents'},
    loadChildren: () => import('../../modules/documents/documents.module').then(m => m.DocumentsModule),
  },
  {
    path: 'products',
    data: { title: 'Sản phẩm'},
    loadChildren: () => import('../../modules/product/product.module').then(m => m.ProductModule),
  },
  {
    path: 'accounts',
    data: { title: 'Tài khoản'},
    loadChildren: () => import('../../modules/account/account.module').then(m => m.AccountModule),
  },
  {
    path: 'cms',
    data: { title: 'CMS'},
    loadChildren: () => import('../../modules/cms/cms.module').then(m => m.CMSModule),
  },
  {
    path: 'master-data',
    data: { title: 'Dữ liệu'},
    loadChildren: () => import('../../modules/master-data/master-data.module').then(m => m.MasterDataModule),
  },
  {
    path: 'users',
    data: { title: 'Users'},
    loadChildren: () => import('../../modules/users/users.module').then(m => m.UsersModule)
  },
  // Pages
  {
    path: 'pages',
    data: {
      title: 'Pages '
    },
    children: [
      {
        path: '',
        redirectTo: '/transaction',
        pathMatch: 'full'
      },
    ]
  },
];
